import React from 'react';
import { graphql } from 'gatsby';
import SingleProductItem from '../components/SingleProductItem';
import { SingleProductGrid } from '../styles/Grids';
import SEO from '../components/SEO';

export default function SingleProductPage({ data }) {
    const { product } = data;
    return (
        <>
            {/* eslint-disable-next-line */}
            <SEO title={product.name} image={product.image?.asset?.fluid?.src}/>
            <SingleProductGrid>
                <SingleProductItem singleProduct={product} />
            </SingleProductGrid>
        </>
    )
}

// This needs to be dynamic based on the slug passed in via context in gatsby-node.js
export const query = graphql`
    query($slug: String!) {
        product: sanityProduct(slug: { current: { eq: $slug } }) {
            id
            _type
            name
            price
            description
            images {
                asset {
                    gatsbyImageData(
                        placeholder: BLURRED
                    )
                    url
                    _id
                }
            }
            slug {
                current
                _key
                _type
            }
            variants {
                sizes
            }
        }
    }
`;